import { lazy, Suspense } from "react";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { ScrollToTop } from "@/components/ui/ScrollToTop";

// Lazy load below-the-fold sections
const TrustBanner = lazy(() => import("@/components/home/TrustBanner").then(m => ({ default: m.TrustBanner })));
const ClientLogosSection = lazy(() => import("@/components/home/ClientLogosSection").then(m => ({ default: m.ClientLogosSection })));
const PrimeEvolutionSection = lazy(() => import("@/components/home/PrimeEvolutionSection").then(m => ({ default: m.PrimeEvolutionSection })));
const VeectoriaPulseSection = lazy(() => import("@/components/home/VeectoriaPulseSection").then(m => ({ default: m.VeectoriaPulseSection })));
const AIAgentsShowcaseSection = lazy(() => import("@/components/home/AIAgentsShowcaseSection").then(m => ({ default: m.AIAgentsShowcaseSection })));
const AdvantagesSection = lazy(() => import("@/components/home/AdvantagesSection").then(m => ({ default: m.AdvantagesSection })));
const PartnersSection = lazy(() => import("@/components/home/PartnersSection").then(m => ({ default: m.PartnersSection })));
const TestimonialSection = lazy(() => import("@/components/home/TestimonialSection").then(m => ({ default: m.TestimonialSection })));
const FAQSection = lazy(() => import("@/components/home/FAQSection").then(m => ({ default: m.FAQSection })));
const ContactFormSection = lazy(() => import("@/components/home/ContactFormSection").then(m => ({ default: m.ContactFormSection })));
const CTASection = lazy(() => import("@/components/home/CTASection").then(m => ({ default: m.CTASection })));

const Index = () => {
  return (
    <>
      <Layout>
        <HeroSection />
        <Suspense fallback={null}>
          <TrustBanner />
          <ClientLogosSection />
          <PrimeEvolutionSection />
          <VeectoriaPulseSection />
          <AIAgentsShowcaseSection />
          <AdvantagesSection />
          <PartnersSection />
          <TestimonialSection />
          <FAQSection />
          <ContactFormSection />
          <CTASection />
        </Suspense>
      </Layout>
      <ScrollToTop />
    </>
  );
};

export default Index;
